import axios from 'axios';
import ConfigConnection from '../config/config.service';
export default class SectionService{
  // API Instance
  configConnection: any = new ConfigConnection();

  get(pageOffset, itemsPerPage){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}section?offset=${pageOffset}&limit=${itemsPerPage}`, config);
  }

  create(section){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.post(`${_.configConnection.apiInstance}section`, section, config);
  }

  edit(section, idSection){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.put(`${_.configConnection.apiInstance}section/${idSection}`, section, config);
  }

  getSurveyById(surveyId){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}survey/${surveyId}`, config);
  }

  getById(idSection){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}section/${idSection}`, config);
  }

  delete_section(idSection){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.delete(`${_.configConnection.apiInstance}section/${idSection}`, config);
  }

  getBySurvey(){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}survey`, config);
  }

  getSurveys(){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}survey`, config);
  }

  getBySection(idSection){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}section/${idSection}`, config);
  }

  getInactive(pageOffset, itemsPerPage){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}section/inactive?offset=${pageOffset}&limit=${itemsPerPage}`, config);
  }

  active_section(idSection, reactivate){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}section/${idSection}/reactivate`, config);
  }
}
